
import Import from "../../../assets/duotone/Import.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ImportIcon({ className, dataTestid = "ImportIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Import data-testid={dataTestid} className={classes} {...rest} />
  );
}
